import { render, staticRenderFns } from "./UrutanKategori.vue?vue&type=template&id=4b23324c&"
import script from "./UrutanKategori.vue?vue&type=script&lang=js&"
export * from "./UrutanKategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports